export default class ResponsiveIframe {

    static initializeEvents() {
        window.addEventListener('message', function (event) {
            if (event.data && event.data.src && event.data.height && !isNaN(event.data.height)) {
                const src = new URL(event.data.src);
                const targetIframe = document.querySelector('iframe[src="' + src.href + '"], iframe[src="' + src.pathname + '"], iframe[src="' + src.pathname + '?"], iframe[src="' + src.pathname + src.search + '"]');
                if (targetIframe) {
                    targetIframe.parentNode.classList.remove('iframe-responsive-wrapper');
                    targetIframe.parentNode.removeAttribute('style');
                    targetIframe.height = parseInt(event.data.height) + 'px';
                }
            }
        }, false);
    }

}